import { writable } from 'svelte/store';

/**
 * Module-level singleton replacing Skeleton 2's drawer-store getter for the
 * single mobile-nav drawer mounted in +layout.svelte. The 4 Skeleton 2
 * call sites (BaseAdminLayout open, SideNavBar children close, settings
 * children close) all converge on this writable.
 */
export const drawerOpen = writable(false);

export function openDrawer(): void {
	drawerOpen.set(true);
}

export function closeDrawer(): void {
	drawerOpen.set(false);
}
